import { render } from "./THQ.vue?vue&type=template&id=eff7c61a"
import script from "./THQ.vue?vue&type=script&lang=js"
export * from "./THQ.vue?vue&type=script&lang=js"

import "./THQ.vue?vue&type=style&index=0&id=eff7c61a&lang=css"
script.render = render

export default script